// Check if the URL contains "personalised-skincare"
if (window.location.href.includes("personalised-skincare") && window.innerWidth > 680) {
  // Select elements with class names "container" and "container--xs"
  const elements = document.querySelectorAll('.container, .container--xs');

  // Loop through each element and apply the margin styles
  elements.forEach(element => {
    element.style.marginLeft = "100px";
    element.style.marginRight = "100px";
  });
}

// Check if the current URL matches the desired one
if (window.location.href.includes("personalised-skincare")) {
    // Select the element by its class
    const pageTitle = document.querySelector('.section-header');
    // Remove the element if it exists
    if (pageTitle) {
        pageTitle.remove();
    }
}

window.addEventListener('message', function(e) {
	    var $iframe = document.getElementById('renude-analysis');
		if($iframe) {
			var eventName = e.data[0];
			var data = e.data[1];
			function createCartWithCustomAttributes(
			sessionId,
			businessId,
			productId,
			mentionedProductId = []
			) {
			// First, check if the cart already has items
			fetch(window.Shopify.routes.root + "cart.js")
				.then((response) => response.json())
				.then((cart) => {
				if (cart.items.length === 0) {
					// The cart is empty, create a cart with a zero-quantity product
					const cartData = {
					items: [
						{
						quantity: 0, // Zero quantity means no visible product
						id: productId, // A valid variant ID for a placeholder product
						properties: {
							session_id: sessionId,
							business_id: businessId,
							mentionedProductId: mentionedProductId,
						},
						},
					],
					};

					fetch(window.Shopify.routes.root + "cart/add.js", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(cartData),
					})
					.then((response) => response.json())
					.then(() => {
						// Update the cart attributes once the cart is created
						updateCartAttributes(sessionId, businessId, mentionedProductId);
					})
					.catch((error) => {
						console.error("Error creating cart:", error);
					});
				} else {
					// The cart already has products, so just update the attributes
					updateCartAttributes(sessionId, businessId, mentionedProductId);
				}
				})
				.catch((error) => {
				console.error("Error checking cart:", error);
				});
			}

			// Function to update cart attributes (session_id, business_id)
			function updateCartAttributes(sessionId, businessId, mentionedProductId) {
			const updates = {
				attributes: {
				session_id: sessionId,
				business_id: businessId,
				mentionedProductId: mentionedProductId,
				},
			};

			fetch(window.Shopify.routes.root + "cart/update.js", {
				method: "POST",
				headers: {
				"Content-Type": "application/json",
				},
				body: JSON.stringify(updates),
			})
				.then((response) => response.json())
				.then((data) => {
				console.log("Cart attributes updated:", data);
				})
				.catch((error) => {
				console.error("Error updating cart attributes:", error);
				});
			}

			switch(eventName) {
				case 'setHeight':
					$iframe.height = data;
					break;
				case 'setTopByWindow':
				window.scrollTo({ top: data, behavior: 'smooth' });
				break;
				case 'setTopByIframe':
				$iframe.scrollIntoView({behavior: 'smooth', block: 'start'});
				break;
			case 'renude-setup-track':
				const payloadData = JSON.parse(data)
					createCartWithCustomAttributes(
					payloadData.session_id,
					payloadData.BID,
					payloadData.external_id,
					payloadData.mentionedProductId
					);
				break;
			}
			if (e.data.action === 'addToCart') {
			/*
				We need to update the below code. the renude iframe's postmessage will send product variantID and quantity.
				{
					action: 'addToCart',
					item: 8445857628424,
					quantity: 1
				}
				window.parent.postMessage({ action: 'addToCart', item: `${8445857628424}`}, '*');
				This postMessage events will be handled by this code block. So we need to add some code to show updated bag icon with count of products or showing cart slide panel. As you can imagine, we should update this if statement code block to archive the goal.
			*/
			// Add item to Shopify cart
			fetch('/cart/add.js', {
				method: 'POST',
				headers: {
				'Content-Type': 'application/json',
				},
				body: JSON.stringify({
				id: e.data.item,  // product variantID
				quantity: e.data.quantity
				}),
			})
			.then(response => response.json())
			.then(data => {
				// Optionally, update the cart UI
				console.log('Item added to cart:', data);
			})
			.catch(error => {
				console.error('Error adding item to cart:', error);
			});
			}
		}
	    
	}, false);